import PaymentTypeEnum from '@/api/Enums/PaymentTypeEnum.js'
import Printer from '@/lib/print/printer.js'
import {clone, sumArrObjProp, toFloat} from '@/lib/helper/helper.js'
import OrderStatusEnum from '@/api/Enums/OrderStatusEnum.js'

export default {
  data() {
    return {}
  },

  computed: {},

  methods: {
    getPaymentTypeNameLang(paymentType) {
      const lang = clone(this.$t('Order.PaymentMethod'))
      delete lang.Title
      const langArray = Object.values(lang)
      const name = langArray.find(payment => payment.Code === paymentType)?.Title || this.$t('Waiter.PrintDeliveryShift.PrintReceipt.Other')
      return name.toLocaleUpperCase(this.$i18n.locale)
    },

    getDeliveryStaffShiftTotals(staff, withShiftStartMoney = true) {
      const paymentTypes = clone(this.appConfig?.PAYMENT_TYPES || [])
      const prepaidActive = paymentTypes.some(p => p.code === PaymentTypeEnum.PREPAID && p.active)
      const orders = staff?.ShiftOrders || []
      const payments = []
      orders.forEach((order) => {
        order.PaymentTransactions.forEach((paymentTransaction) => {
          payments.push(paymentTransaction)
        })
      })

      const totals = {
        Cash: {
          Active: true,
          Orders: orders.filter(order => parseInt(order.StatusId) !== OrderStatusEnum.Canceled && order.PaymentTransactions.some(payment => PaymentTypeEnum.isCash(payment.PaymentType))).length,
          Total : toFloat(sumArrObjProp(payments.filter(payment => PaymentTypeEnum.isCash(payment.PaymentType)), 'Amount'))
        },
        Card: {
          Active: true,
          Orders: orders.filter(order => parseInt(order.StatusId) !== OrderStatusEnum.Canceled && order.PaymentTransactions.some(payment => PaymentTypeEnum.isAnyCard(payment.PaymentType))).length,
          Total : toFloat(sumArrObjProp(payments.filter(payment => PaymentTypeEnum.isAnyCard(payment.PaymentType)), 'Amount'))
        },
        Prepaid: {
          Active: prepaidActive,
          Orders: prepaidActive ? orders.filter(order => parseInt(order.StatusId) !== OrderStatusEnum.Canceled && order.PaymentTransactions.some(payment => PaymentTypeEnum.isPrepaid(payment.PaymentType))).length : 0,
          Total : prepaidActive ? toFloat(sumArrObjProp(payments.filter(payment => PaymentTypeEnum.isPrepaid(payment.PaymentType)), 'Amount')) : toFloat(0)
        },
        Other: {
          Active: true,
          Orders: orders.filter(order => parseInt(order.StatusId) !== OrderStatusEnum.Canceled && order.PaymentTransactions.some(payment => !PaymentTypeEnum.isCash(payment.PaymentType) && !PaymentTypeEnum.isAnyCard(payment.PaymentType) && (prepaidActive ? !PaymentTypeEnum.isPrepaid(payment.PaymentType) : true))).length,
          Total : toFloat(sumArrObjProp(payments.filter(payment => !PaymentTypeEnum.isCash(payment.PaymentType) && !PaymentTypeEnum.isAnyCard(payment.PaymentType) && (prepaidActive ? !PaymentTypeEnum.isPrepaid(payment.PaymentType) : true)), 'Amount'))
        },
        Canceled: {
          Active: true,
          Orders: orders.filter(order => parseInt(order.StatusId) === OrderStatusEnum.Canceled).length,
          Total : toFloat(sumArrObjProp(orders.filter(order => parseInt(order.StatusId) === OrderStatusEnum.Canceled), 'OrderTotal'))
        },
        Total: 0
      }
      totals.Total = toFloat(totals.Cash.Total + totals.Card.Total + totals.Prepaid.Total + totals.Other.Total) + toFloat(withShiftStartMoney ? staff?.ShiftStartMoney || 0 : 0)
      totals.TotalExcluded = toFloat(totals.Cash.Total) + toFloat(withShiftStartMoney ? staff?.ShiftStartMoney || 0 : 0)

      return totals
    },

    onPrintDeliveryShift(printer) {
      if (!printer) return

      const printWithOrders = this.appConfig.LOCATION_DATA?.PrintDeliveryStaffShiftWithOrders ?? true
      let printContents = ''

      let totalOrdersExcludingCanceled = 0

      printContents += '<div style="width: 100%; text-align: center; margin-top: 12px;"><img style="" width="' + this.$refs.barcodeCanvas.$el.children[0].width + 'px" height="' + this.$refs.barcodeCanvas.$el.children[0].height + 'px" src="' + this.$refs.barcodeCanvas.$el.children[0].toDataURL('image/jpeg') + '" /></div>'
      printContents += '<div style="width: 100%; text-align: center;">'
      printContents += '<span style="position:relative; top: -10px; font-family: Arial; font-size: 12px; text-align: center;">' + (String(this.selectedDeliveryStaff.Firstname + ' ' + this.selectedDeliveryStaff.Lastname).toLocaleUpperCase(this.$i18n.locale)) + '</span>'
      printContents += '</div>'

      if (this.selectedDeliveryStaff && this.selectedDeliveryStaff.HasActiveShift) {
        printContents += '' +
          '<div style="margin-bottom: 20px; font-family: Arial; font-size: 12px; text-align: center;">' +
          '<div style="font-size: 14px;"><strong>' + this.$t('Delivery.PrintDeliveryShift.PrintReceipt.StartShift') + '</strong></div>' +
          '<div style="font-size: 34px; font-weight: 400;">' + this.$options.filters.currency(this.selectedDeliveryStaff.ShiftStartMoney) + '</div>' +
          '<div>' + this.selectedDeliveryStaff.ShiftStartDateTime + '</div>' +
          '</div>'

        for (let i = 0; i < this.selectedDeliveryStaff.ShiftOrders.length; i++) {
          const isCanceled = parseInt(this.selectedDeliveryStaff.ShiftOrders[i].StatusId) === 19
          if (!isCanceled) totalOrdersExcludingCanceled++

          if (printWithOrders) {
            printContents += '' +
              '<div style="width: 100%; margin-top: 10px; font-family: Arial; font-size: 10px; text-align: center; text-decoration: ' + (isCanceled ? 'line-through' : 'none') + ';">' +
              '<span><strong>#' + this.selectedDeliveryStaff.ShiftOrders[i].Id + '</strong></span>' +
              '<span>&nbsp;' + (parseInt(this.selectedDeliveryStaff.ShiftOrders[i].OrderTypeId) === 1 ? this.$t('Delivery.PrintDeliveryShift.PrintReceipt.Delivery').toLocaleUpperCase(this.$i18n.locale) : this.$t('Delivery.PrintDeliveryShift.PrintReceipt.Collection').toLocaleUpperCase(this.$i18n.locale)) + '</span>' +
              '<span>&nbsp;' + (parseInt(this.selectedDeliveryStaff.ShiftOrders[i].StatusId) === 19 ? this.$t('Delivery.PrintDeliveryShift.PrintReceipt.Canceled').toLocaleUpperCase(this.$i18n.locale) : '') + '</span>'

            let totalCash = 0
            let totalExcluded = 0

            if (this.selectedDeliveryStaff.ShiftOrders[i].PaymentTransactions.length > 0) {
              printContents += '<div style="font-family: Arial; font-size: 8px;">'
              this.selectedDeliveryStaff.ShiftOrders[i].PaymentTransactions.forEach((paymentTransaction) => {
                const isCash = PaymentTypeEnum.isCash(paymentTransaction.PaymentType)
                const isCard = PaymentTypeEnum.isAnyCard(paymentTransaction.PaymentType)
                totalCash += isCash ? toFloat(paymentTransaction.Amount) : 0
                totalExcluded += !isCash ? toFloat(paymentTransaction.Amount) : 0
                printContents += '<div style="text-decoration: ' + (!isCash ? 'line-through' : 'none') + ';">&nbsp;' + (isCash ? this.$t('Delivery.PrintDeliveryShift.PrintReceipt.Cash').toLocaleUpperCase(this.$i18n.locale) : isCard ? this.$t('Delivery.PrintDeliveryShift.PrintReceipt.Card').toLocaleUpperCase(this.$i18n.locale) : this.getPaymentTypeNameLang(paymentTransaction.PaymentType)) + '<span><strong>&nbsp;' + this.$options.filters.currency(paymentTransaction.Amount || 0) + '</strong></span></div>'
              })

              printContents += '</div>'
            }

            if (totalExcluded > 0) {
              printContents += '<div><strong>&nbsp;' + this.$t('Order.OrderDetailsDialog.Transaction.Total').toLocaleUpperCase(this.$i18n.locale) + ': ' + this.$options.filters.currency(totalCash) + '</strong> &nbsp;<span style="text-decoration: line-through;">(' + this.$options.filters.currency(this.selectedDeliveryStaff.ShiftOrders[i].OrderTotal) + ')</span></div>'
            } else {
              printContents += '<div><strong>&nbsp;' + this.$t('Order.OrderDetailsDialog.Transaction.Total').toLocaleUpperCase(this.$i18n.locale) + ': ' + this.$options.filters.currency(this.selectedDeliveryStaff.ShiftOrders[i].OrderTotal) + '</strong></div>'
            }

            printContents += '<div><span>&nbsp;' + this.selectedDeliveryStaff.ShiftOrders[i].DateAdded + ' - ' + this.selectedDeliveryStaff.ShiftOrders[i].TimeAdded + '</span></div>'
            printContents += '</div>'
          }
        }

        printContents += '' +
          '<div style="width: 100%; margin-top: 20px; font-family: Arial; font-size: 12px; text-align: center;">' +
          '<div style="font-size: 14px;"><strong>' + this.$t('Delivery.Common.ShiftTotal') + '</strong></div>' +
          '<div style="font-size: 14px;"><strong>' + totalOrdersExcludingCanceled + ' ' + this.$tc('Order.Title', totalOrdersExcludingCanceled) + '</strong></div>' +
          '<div style="font-size: 34px; font-weight: 400;">' + this.$options.filters.currency(this.getDeliveryStaffShiftTotals(this.selectedDeliveryStaff).TotalExcluded) + '</div>' +
          '<div><strong>' + this.$t('Delivery.PrintDeliveryShift.PrintReceipt.WithoutStart') + '</strong> ' + this.$options.filters.currency(this.getDeliveryStaffShiftTotals(this.selectedDeliveryStaff, false).TotalExcluded) + '</div>' +
          '<div>&nbsp;</div>'

        printContents += this.getDeliveryStaffShiftTotals(this.selectedDeliveryStaff, false).Cash.Active ? '<div><strong>' + this.$t('Waiter.PrintDeliveryShift.PrintReceipt.Cash').toLocaleUpperCase(this.$i18n.locale) + ':</strong> ' + this.$options.filters.currency(this.getDeliveryStaffShiftTotals(this.selectedDeliveryStaff, false).Cash.Total) + '</div>' : ''
        printContents += this.getDeliveryStaffShiftTotals(this.selectedDeliveryStaff, false).Card.Active ? '<div><strong>' + this.$t('Waiter.PrintDeliveryShift.PrintReceipt.Card').toLocaleUpperCase(this.$i18n.locale) + ':</strong> ' + this.$options.filters.currency(this.getDeliveryStaffShiftTotals(this.selectedDeliveryStaff, false).Card.Total) + '</div>' : ''
        printContents += this.getDeliveryStaffShiftTotals(this.selectedDeliveryStaff, false).Prepaid.Active ? '<div><strong>' + this.$t('Waiter.PrintDeliveryShift.PrintReceipt.Prepaid').toLocaleUpperCase(this.$i18n.locale) + ':</strong> ' + this.$options.filters.currency(this.getDeliveryStaffShiftTotals(this.selectedDeliveryStaff, false).Prepaid.Total) + '</div>' : ''
        printContents += this.getDeliveryStaffShiftTotals(this.selectedDeliveryStaff, false).Other.Active ? '<div><strong>' + this.$t('Waiter.PrintDeliveryShift.PrintReceipt.Other').toLocaleUpperCase(this.$i18n.locale) + ':</strong> ' + this.$options.filters.currency(this.getDeliveryStaffShiftTotals(this.selectedDeliveryStaff, false).Other.Total) + '</div>' : ''
        printContents += '<div><strong>' + this.$t('Order.OrderDetailsDialog.Transaction.Total').toLocaleUpperCase(this.$i18n.locale) + ':</strong> ' + this.$options.filters.currency(this.getDeliveryStaffShiftTotals(this.selectedDeliveryStaff, false).Total) + '</div>'
        printContents += '</div>'
      }

      const html = '<html>' +
        '<head>' +
        '<style>' +
        ' @page {' +
        '            width: 100%;' +
        '            margin-left   : 0px;' +
        '            margin-right  : 0px;' +
        '            margin-top    : 0px;' +
        '            margin-bottom : 0px;' +
        '        }' +
        'body { width: 100%; border: 0; margin: 0; overflow : hidden; }' +
        '@media print { body { width: 100%; overflow : hidden; border: 0; margin: 0; } }' +
        '</style>' +
        '</head>' +
        '<body>' + printContents + '</body>' +
        '</html>'

      // console.log(html);

      this.$bus.$emit('app-show-notification', {
        body: this.$t('Delivery.PrintDeliveryShift.Notification'),
        type: 'info',
        icon: 'print'
      })

      Printer.printStaffShift(html, printer.name)
    }
  }
}
